import { useEffect, useRef } from 'react';

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function Recaptcha({ onChange }) {
  const containerRef = useRef(null);
  const widgetId = useRef(null);

  useEffect(() => {
    let cancelled = false;
    let pollId = null;

    const render = () => {
      if (cancelled || !containerRef.current || widgetId.current !== null) return;
      if (!window.grecaptcha || !window.grecaptcha.render) return;
      widgetId.current = window.grecaptcha.render(containerRef.current, {
        sitekey: SITE_KEY,
        theme: 'dark',
        callback: (token) => onChange(token),
        'expired-callback': () => onChange(''),
        'error-callback': () => onChange(''),
      });
    };

    if (window.grecaptcha && window.grecaptcha.render) {
      render();
    } else {
      pollId = setInterval(() => {
        if (window.grecaptcha && window.grecaptcha.render) {
          clearInterval(pollId);
          render();
        }
      }, 250);
    }

    return () => {
      cancelled = true;
      if (pollId) clearInterval(pollId);
    };
  }, [onChange]);

  if (!SITE_KEY) return null;
  return <div ref={containerRef} />;
}
